import CityPageTemplate from "../city-template/CityPageTemplate";
import { grandHavenConfig } from "./data";

export default function GrandHavenPage() {
  return <CityPageTemplate config={grandHavenConfig} />;
}